export default "__VITE_ASSET__pDv9VE2w__"